var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Grid } from './Common';
import { Row } from './Row';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-fbljra" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var HeaderRow = styled(Grid).withConfig({ displayName: "HeaderRow", componentId: "sc-15yxdha" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.1);\n  grid-auto-rows: 16px;\n  padding: 32px 16px 8px;\n"], ["\n  background: ", ";\n  box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.1);\n  grid-auto-rows: 16px;\n  padding: 32px 16px 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black100;
});
var Th = styled.p.withConfig({ displayName: "Th", componentId: "sc-smrsmy" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"], ["\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"])));
var ReportNameTh = styled(Th).withConfig({ displayName: "ReportNameTh", componentId: "sc-btnl3g" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-column: 1 / span 2;\n"], ["\n  grid-column: 1 / span 2;\n"])));
var Table = function (_a) {
    var rows = _a.rows, groupId = _a.groupId, rest = __rest(_a, ["rows", "groupId"]);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsxs(HeaderRow, { children: [_jsx(ReportNameTh, { children: "report" }, void 0), _jsx(Th, { children: "version" }, void 0), _jsx(Th, { children: "date" }, void 0), _jsx(Th, {}, void 0)] }, void 0), rows === null || rows === void 0 ? void 0 : rows.map(function (row) {
                var url = "/api/teachers/reports/groups/" + groupId + "/download?reportId=" + row.id;
                return _jsx(Row, __assign({}, row, { apiUrl: url, groupId: groupId }), row.id);
            })] }), void 0));
};
export { Table };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
